"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    workOrderModel: {
        slots: {
            morning: 'Morning',
            afternoon: 'Afternoon'
        },
        status: {
            planed: 'To plan',
            done: 'Realized',
            proceed: 'In progress',
            notProceed: 'Not realized',
            toBePlaned: 'To be planned'
        },
        engagement: {
            withRdv: 'with RDV',
            withoutRdv: 'without RDV'
        },
        reasons: {
            101: 'Unavailable',
            102: 'Assignment error',
            103: 'Missing material',
            104: 'Intervention already carried out',
            105: 'Bad weather',
            106: 'Site or meter inaccessible',
            107: 'Customer refusal',
            108: 'Customer absent',
            109: 'Missing authorization',
            110: 'Temporary technical impossibility',
            111: 'Permanent technical impossibility',
            112: 'Security issue',
            113: 'Diagnostic error',
            114: 'No problem identified in the field'
        }
    },
    geographicAddressModel: {
        building: 'Building',
        stairs: 'Stair',
        floor: 'Floor',
        door: 'Door'
    },
    cookiesConfig: {
        banner: {
            rejectCookiesLabel: 'Refuse all',
            acceptCookiesLabel: 'Accept all',
            toggleMenuPanelLabel: 'Configure your cookies',
            infoText: 'When you browse this site, cookies are placed to ensure the functioning of the site, to compile visit statistics and to facilitate your identification with your customer account.'
        },
        optionSession: {
            title: 'Session cookies',
            desc: 'These cookies allow you to facilitate your access to your customer account. These cookies are not essential for navigation. You can refuse their storage by disabling them.'
        },
        panel: {
            OptionsTitleList: 'Manage cookies preferences',
            titlePanel: 'Privacy preference center',
            contentPanel: 'Cookies are placed on your computer, smartphone or tablet (hereinafter the "Device") when you visit the {weburl} site. Cookies are small text files placed on your Device, the details and purposes of which are detailed below. Cookies are managed by your internet browser and only the issuer of a cookie may read or modify the information contained therein.',
            alwayActifLabel: 'Always active',
            rejectAllCookiesLabel: 'Refuse all',
            acceptAllCookiesLabel: 'Accept All',
            requiredCookie: {
                title: 'Functional cookies',
                desc: 'These cookies are necessary for the site to function and can therefore not be refused.'
            },
            optionSession: {
                title: 'Session cookies',
                desc: 'These cookies are necessary for the site to function and can therefore not be refused.'
            },
            optionAnalytic: {
                title: 'Audience measurement cookies',
                desc: 'Subject to your choices, these cookies allow us to measure traffic to our site and thus adapt it to the needs of its visitors. These audience measurement cookies are placed via the Matomo tool. These cookies are not essential for browsing our site. You can oppose their deposit by deactivating them.'
            },
            policyTitle: 'Cookies policy',
            policyMessage: 'To learn more, see our cookies policy:'
        }
    },
    login: {
        title: 'Sign in',
        submitButton: 'Login',
        customerAreaSubtitle: 'Customer Area',
        forgetPassword: 'Forgot your password ?',
        CreateAccountTitle: "Don't have a customer area ?",
        CreateAccountButtton: 'Create your account',
        UpdatePassWordButton: 'Change my password',
        WelcomeTitle: 'Welcome to your customer area',
        WelcomeDesc: 'The customer area allows you to view your personal data, your meter reading, your account balance, your invoices and the interventions planned at your home.',
        WelcomeBtnLabel: 'Return to public site',
        DiscoverAppLabel: 'Discover our Customer Space application',
        timeoutSessionMessage: 'Your session has expired, please log in again.',
        DiagnosticButton: 'Installation Diagnostic'
    },
    moveIn: {
        errors: {
            numberRequired: 'The input needs to be filled by numbers only',
            numberIsTooHigh: 'The input can not exceed {max}',
            numberIsTooLow: 'The input can not be less than {min}',
            fieldLengthTooShort: 'The input length needs to be at least {min} characters',
            fieldLengthTooLong: 'The input can not exceed {max} characters'
        },
        billingAddress: {
            headerText1: 'My billing',
            headerText2: 'address',
            sameAddressQuestion: 'Is your billing address the same as your meter address?',
            streetAddress: { label: 'Street name and number', placeholder: '' },
            zipCode: { label: 'Zip code', placeholder: '' },
            commune: { label: 'Town', placeholder: '' },
            autoCompleteAddress: {
                label: 'Billing address',
                placeholder: 'I type in my billing address'
            },
            precision: { label: 'Address precision', placeholder: '' },
            lieuDit: { label: 'Locality', placeholder: '' },
            cedex: { label: 'Cedex', placeholder: '' },
            country: { label: 'Country', placeholder: '' }
        },
        meterAddress: {
            headerText1: 'My meter',
            headerText2: 'address',
            streetNumber: { label: 'N°', placeholder: '' },
            streetAddress: { label: 'Street', placeholder: '' },
            zipCode: { label: 'Zip code', placeholder: '' },
            commune: { label: 'Town', placeholder: '' },
            autoCompleteAddressV2: {
                label: 'Connection address',
                placeholder: 'I enter the address where my meter is located'
            },
            autoCompleteAddress: {
                label: 'Meter Address',
                placeholder: 'I Type in my meter address '
            },
            addressComplement: {
                label: 'Complementary information',
                placeholder: ''
            },
            building: { label: 'Building', placeholder: '' },
            stairs: { label: 'Stairs', placeholder: '' },
            floor: { label: 'Floor', placeholder: '' },
            door: { label: 'Door', placeholder: '' },
            backButton: 'Go back to the simplified form',
            cantFindMyAddress: "I can't find my address"
        },
        residenceInfos: {
            residenceTypes: {
                main: 'Main',
                secondary: 'Secondary',
                commercial: 'Commercial space',
                mixed: 'Mixed'
            },
            waterUsageTypes: {
                domestical: 'Domestic',
                professional: 'Professional',
                industrial: 'Industrial'
            },
            ownershipTypes: {
                owner: 'Landlord',
                renter: 'Tenant'
            },
            lastOccupantQuestion: 'Do you know the name of the last owner ?',
            runningWaterWarningQuestion: 'Do you have running water in your new household?',
            runningWaterWarningPart1: "The water shortage might be due to your faucet being closed.Please Make sure it's open",
            runningWaterWarningPart2: "If you don't have running water in your household, our customer services will contact you shortly to book an appointment.",
            ownershipStatus: { label: 'I am', placeholder: '' },
            flatCountInResidence: {
                label: 'Flat count in the residence',
                placeholder: 'Flat count in the residence'
            },
            numberOfInhabitants: {
                label: 'Person count in the flat',
                placeholder: 'Example : 2 - Maximum : 12'
            },
            residenceType: {
                label: 'Residence',
                placeholder: 'I select my residence type'
            },
            waterUsageType: { label: 'Water usage', placeholder: '' },
            runningWater: { label: '', placeholder: '' },
            knownLastOccupant: { label: '', placeholder: '' },
            formerOccupantLastName: {
                label: 'Last name',
                placeholder: "Former occupant's last name"
            },
            formerOccupantFirstName: {
                label: 'First name',
                placeholder: "Former occupant's first name"
            },
            referenceClient: {
                label: 'Client reference',
                placeholder: "Former occupant's client reference"
            },
            formerOccupant: {
                title: 'Former occupant',
                message: "I don't know the former occupant"
            }
        },
        stepper: {
            MyInformation: 'My information',
            CoHolderHInformation: 'My joint account holder information',
            MyMeterInfos: 'My meter information',
            MyMeterAddress: 'My meter address',
            MyBillingAddress: 'My billing address',
            MyConsumptionEstimation: 'My consumption (estimate)',
            MyBillingInfos: 'My billing information'
        },
        loginWidgetTitle: "I'm moving in",
        loginButton: 'Subscribe',
        requiredFieldsNotice: '* Required fields',
        yesText: 'Yes',
        NoText: 'No',
        title: {
            label: 'Title',
            mister: 'Mister',
            madame: 'Madame'
        },
        email: {
            label: 'E-mail address',
            placeholder: 'My email address',
            confirmationPlaceholder: 'Confirm my email address'
        },
        birthDate: {
            label: 'Date of Birth'
        },
        birthCountry: {
            label: 'Birth country',
            placeholder: 'My birth country'
        },
        birthCity: {
            label: 'Birth city',
            placeholder: 'My birth city'
        },
        identityJustificationFile: {
            label: 'Identity justification',
            selectButton: 'Select a document',
            indocation: 'Accepted formats : .pdf .jpg .png',
            deleteButton: 'Delete'
        },
        townEligibility: {
            headerTextPart1: 'Start my subscription',
            headerTextPart2: 'process',
            eligibilityError: 'The water services in this town are not provided with our care. Please contact you town officials to learn more.',
            townInputLabel: 'Please indicate the town name or zipcode',
            townInputPlaceholder: 'at least one character ...'
        },
        publicSiteRedirect: {
            useOldWebsiteButton: 'Access the public website',
            privateClientOnlyOption: 'This functionality is not yet available for enterprises and administrations.',
            notSupportedCommuneError: 'This functionality is not yet available for your commune.',
            pleaseUseOldWebsite: "Please use our public website's form."
        },
        privateOrProfessional: {
            private: 'Home owner',
            iAm: 'I am',
            professional: 'Enterprise, Administration'
        },
        prerequiste: {
            readyButton: 'I am ready',
            headerPart1: 'To be able to fill this from,',
            headerPart2: 'please make sure you have these documents :',
            counterText: 'The meter serial number, the meter index with the reading date and a clear image of the meter',
            identityCard: 'Your ID and your joint account holder ID (national ID or passport)',
            creditCard: 'your banking information (IBAN)'
        },
        myInfos: {
            header: 'My information',
            firstName: {
                label: 'First name',
                placeholder_1: 'The first name written on my ID (30 character max)',
                placeholder_2: 'The first name written on my ID (30 character max)'
            },
            lastName: {
                label: 'Last name',
                placeholder_1: 'The last name written on my ID (30 character max)',
                placeholder_2: 'The last name written on my ID (30 character max)'
            },
            phone: 'Phones',
            landlinePhone: {
                label: 'Landline number',
                placeholder: 'My landline number'
            },
            mobilePhone: {
                label: 'Phone number',
                placeholder: 'My mobile phone number'
            },
            acceptsEmailNewsletter: {
                label: "I agree to receive by email communications and news relating to the company's services"
            },
            acceptsSmsNewsletter: {
                label: "I agree to receive by SMS communications and news relating to the company's services"
            },
            indicator1: '(1) Your email address will be used to communicate with you within the framework of your subscription contract, in the event of overconsumption alerts as well as to send you advice and information concerning new products from Saur and its services. You can go to your customer area to manage your preferences.',
            indicator2: '(2) One of the two telephone numbers is required. Your number will be used to send you information or alerts concerning an event requiring special attention from you.',
            indicator3: '(3) By validating this step, your data will be collected and kept for a period equal to one (1) month. As part of our efforts to improve the quality of our services and our site, our internal services may contact you if you do not complete your subscription on our site. You can exercise your right of access, rectification, opposition and deletion by e-mail to dpo@saur.com.'
        },
        myCoInfos: {
            headerTextPart1: "Joint account holder's",
            headerTextPart2: 'information',
            isWithJointAccountQuestion: 'Do you have a joint account holder ?',
            firstName: {
                label: 'First name',
                placeholder_1: 'The first name written on his/her ID',
                placeholder_2: 'The first name written on his/her ID (30 character max)'
            },
            lastName: {
                label: 'Last name',
                placeholder_1: 'The last name written on his/her ID',
                placeholder_2: 'The last name written on his/her ID (30 character max)'
            },
            email: {
                label: 'Email address',
                placeholder: 'His email address',
                confirmationPlaceholder: 'Confirmation of his email address'
            },
            mobilePhone: {
                label: 'Mobile phone',
                placeholder: 'His mobile number'
            },
            landlinePhone: {
                label: 'Landline phone',
                placeholder: 'His landline phone number'
            },
            birthCountry: {
                label: 'Birth country',
                placeholder: 'The country of birth listed on his identity document'
            },
            birthCity: {
                label: 'Birth city',
                placeholder: 'The city of birth written on his identity document'
            }
        },
        meterInfos: {
            errorScreen: {
                title: 'We were unable to identify your meter.',
                newTitle: "We still can't identify your meter.",
                newMessageOne: 'Can you give us more information about your',
                newMessageTwo: 'address and/or your meter?',
                message: 'An Intervention by our team may be in order. Our customer service representative might contact you soon.'
            },
            additionalInformation: {
                label: 'additional information.',
                placeholder: 'address/meter details (200 characters Max)'
            },
            serialNumber: {
                label: 'Meter Number',
                placeholder: '11 characters for meter number'
            },
            meterNumber: {
                label: 'Meter Number',
                placeholder: 'My meter number'
            },
            entryDate: {
                label: 'Entry date',
                placeholder: '    MM     /     JJ     /     AAAA'
            },
            meterIndex: {
                label: 'I fill in the 4 to 6 number displayed in my meter index',
                placeholder: '0 0 0 0'
            },
            meterPhoto: { label: 'Photo of the meter' },
            titlePart1: 'My',
            unknownMeterId: "We couldn't identify your meter based on it's identifier. Please re-check your input before going to the next step.",
            titlePart2: 'Meter',
            addAPhoto: 'Add a photo',
            nextButton: 'Advance to the next step',
            cancelButton: 'Cancel',
            meterInfosPopup: {
                myMeterIndex: 'My meter reading',
                meterIndexPostion: 'Where can I find the meter index ?',
                meterIndexIndicationPart1: 'In the « meter index» field,  ',
                meterIndexIndicationPart2: 'please fill in only the 4 to 6 numbers in white with black background or in black with white background. ',
                meterIndexIndicationPart3: 'These numbers represent the meter index that you can find in your invoice, they represent the meter index in m3 (1 m3=1000 l)'
            },
            meterRegistrationPopup: {
                myMeterNumber: 'My meter number',
                meterNumberPostion: 'Where can I find it?',
                meterNumberIndicationPart1: 'In the « counter number » box, ',
                meterNumberIndicationPart2: 'Enter only the 11 characters present on your counter. ',
                meterNumberIndicationPart3: 'Your counter number may be in a different location than the two examples above.'
            }
        },
        consEstimation: {
            headerTextPart1: 'Consumption',
            headerTextPart2: 'Estimation',
            isYearlyConsumptionKnownQuestion: 'Do you have an idea about your yearly consumption in m3 ?',
            yearlyConsumption: {
                label: 'Yearly Consumption'
            },
            numberOfInhabitants: {
                label: 'Number of people in the household'
            },
            consumptionEstimateLabel: 'Estimate',
            consumptionEstimationInfo: 'The consumption estimation is an important step, it will be used either for the monthly payment of your billing, or for your interim bills.',
            consumptionEstimationNotice: '*Estimation based on the national average per person and and the average price for your commune, not including service charges.',
            consumptionEstimateMonthlyValue: 'monthly',
            consumptionEstimateMiddleInfo: 'that is',
            consumptionEstimateTooHighError: 'Your consumption does not seem to be related to a personal consumption.',
            consumptionEstimateTooLowWarning: 'Warning: you do not plan to consume water all year round.',
            consumptionEstimateClientService: 'Please contact your customer service.',
            consumptionEstimateClientServiceButton: 'Contact my customer service'
        },
        paymentInfos: {
            title: {
                firstpart: 'My',
                secondpart: 'billing'
            },
            paymentType: {
                label: 'Payment method',
                placeholder: 'Monthly withdrawal'
            },
            iban: {
                label: 'IBAN'
            },
            withdrawalDay: {
                label: 'Withdrawal day',
                placeholder: 'I select my withdrawal day'
            },
            paymentTypes: {
                monthly: 'Monthly withdrawal',
                bill: 'Withdrawal on invoice',
                other: 'Other payment methods'
            },
            noticeMessage: {
                firstline: 'You can pay your bill by credit',
                secondline: 'card directly on your customer area.'
            },
            billingInfos: {
                backtopayment: 'Back to my billing choices',
                gotoebilling: 'I switch to electronic billing for free',
                firsticonword: 'I will be notified by email when a new invoice is made available',
                secondiconword: 'I can access it online 24 hours a day, 7 days a week',
                thirdiconword: 'I contribute to reducing the consumption of natural resources',
                yesbutton: 'YES',
                nobutton: 'I am not interested',
                cancelbutton: 'Cancel'
            }
        },
        recap: {
            headerTextPart1: 'Summary of',
            headerTextPart2: 'my information',
            myInformation: {
                identityLabel: 'Identity',
                dateOfBirthLabel: 'Date of birth',
                countryOfBirthLabel: 'Birth country',
                cityOfBirthLabel: 'Birth city',
                emailLabel: 'Email',
                mobilePhoneLabel: 'Mobile Phone',
                landlineLabel: 'Landline number',
                acceptsEmailNewsletterOnly: 'I agree to receive communications and news relating to company services by email.',
                acceptsSmsNewsletterOnly: 'I agree to receive communications and news relating to company services by SMS.',
                acceptsEmailAndSmsNewsletters: 'I agree to receive communications and news relating to company services by email and SMS.',
                doesNotAcceptNewsletters: 'I do not wish to receive any communication or news relating to company services by email or SMS.'
            },
            myCoInformation: {
                identityLabel: 'Identity',
                dateOfBirthLabel: 'Date of birth',
                countryOfBirthLabel: 'Birth country',
                cityOfBirthLabel: 'Birth city',
                emailLabel: 'Email',
                mobilePhoneLabel: 'Mobile Phone',
                landlineLabel: 'Landline number',
                noCoInfoMessage: 'No joint account holder on the contract.'
            },
            myMeterInfos: {
                serialNumberLabel: 'Meter number',
                entryDateLabel: 'Residence entry date',
                meterIndexLabel: 'Meter index'
            },
            myMeterAddress: {
                meterAddressLabel: 'Meter address',
                ownershipStatusLabel: 'Ownership status',
                flatCountInResidenceLabel: 'Flat count in residence',
                numberOfInhabitantsLabel: 'Number of inhabitants',
                residenceTypeLabel: 'Residence type',
                waterUsageTypeLabel: 'Water usage type',
                runningWaterLabel: 'There is water in the residence.',
                noRunningWaterLabel: 'No water in the residence.'
            },
            myBillingAddress: {
                billingAddressLabel: 'Billing address',
                sameAsMeterAddressMessage: 'My billing address is the same as the meter address.'
            },
            myConsEstimation: {
                yearlyConsumptionLabel: 'Yearly consumption',
                numberOfInhabitantsLabel: 'Number of inhabitants'
            },
            myBillingInfos: {
                paymentTypeLabel: 'Payment mode',
                ibanLabel: 'IBAN',
                withdrawalDayLabel: 'Withdrawal day',
                eBillServiceLabel: 'eBill Service',
                withdrawalDayValuePart2: 'of the month'
            }
        },
        conditionsValidation: {
            headerTextPart1: 'Conditions',
            headerTextPart2: 'Validation',
            firstConditionMessage: 'I certify on my honor the exactitude of the information given and I acknowledge that this order constitutes an obligation of payment.',
            secondConditionMessage: 'In accordance with article L121-21-5 of the Consumer Code, the water supply will be effective within 14 days of the validation of this contract. I therefore request the execution of the service before the end of the 14-day withdrawal period mentioned in article L121-21-5 of the Consumer Code. I am informed of my obligation to pay any service provision related to the commissioning of my connection even if my right of withdrawal is used. This right can be exercised by simply sending a letter or email.',
            consultRgpd: 'To learn more, please visit ',
            consultRgpdLink: 'our personal data protection policies.',
            errorMessage: 'Please check the two boxes related to the above conditions before validating.'
        },
        moveInSuccess: {
            successMessage: 'CONGRATULATIONS!',
            requestMessage: 'Your request has been taken into account!',
            processingMessage: 'It will be processed as soon as possible by customer service.'
        },
        moveInFailure: {
            errorMessage: 'AN ERROR HAS OCCURRED',
            errorDescriptionMessage: 'A technical problem prevented the validation of your request.',
            tryAgainMessage: 'Please, try again.'
        },
        moveInCancel: {
            header: 'Cancel',
            warningMessage: 'Please note, all the information entered will be lost and your subscription request will not be saved.'
        },
        buttons: {
            nextStep: 'Move to the next step',
            nextStepV2: 'Move to the next step (3)',
            nextStepV1: 'Move to the next step (1)',
            finalize: 'Finalize my contract',
            validate: 'Validate',
            close: 'Close',
            abandon: 'Abandon the creation of my request',
            revalidate: 'Validate the creation of my request',
            cancel: 'Cancel'
        }
    },
    ContractCancellation: {
        title: 'Contract Cancellation',
        userIdentification: 'My authentication'
    },
    CreateAccount: {
        title: 'Create my customer area',
        invalidTokenError: 'The website link provided is invalid. Please use the link below to recreate your account.',
        stepOneInThree: {
            referenceUsed: 'This reference is linked to an existing account',
            stepOne: 'step 1/3',
            numberClientReference: 'My customer reference (10 numbers)',
            whereToFindClientReference: 'Where to find it ?',
            whereToFindFullClientName: 'Where to find it ?',
            clientName: 'My name (appearing on my invoice)',
            clientFirstLastName: 'My name and first name (appearing on my invoice)',
            notClientYet: 'Not a customer yet ?',
            rdvHeading: 'Go to our section',
            iMoveIn: 'I move in',
            legaleNotice: 'Saur, as data controller, located 11, chemin de Bretagne - 92130 Issy-les-Moulineaux, encountered processing personal data concerning you to allow the creation of an account, the management of your subscription via a dedicated area on the Saur site. In application of the applicable regulations, you have the right to interrogate, access, rectify, erase, limit processing, data portability, withdraw your consent to processing at any time, and d opposition as well as the right to define parent directives regarding the fate of your data after your death. You can exercise these rights with Saur by e-mail at dpo@saur.com. These rights can also be exercised by post to the following address: SAUR S.A.S., for the attention of the Data Protection Officer, 11 chemin de Bretagne 92130 Issy-les-Moulineaux. To find out more, you can consult our personal data protection policy.',
            indicationToFindClientReference: 'This reference is available at the top right of your invoice',
            indicationToFindClientReferenceSubtitle: 'To reported',
            helpNeededQuestion: 'Need help ?',
            writeUs: 'Write to us via the',
            formContact: 'contact form',
            subscriptionPending: "Your customer area's data are not yet ready. Please try again later.",
            helpFullClientName: {
                title: 'The name and last name are located at the top right of your invoice',
                fullClientName: 'Client name and last name'
            },
            subscriptionUnpermited: 'Creation of the customer area is impossible. Please contact customer service.'
        },
        stepTwoInThree: {
            emailUsedError: 'This email address is linked to an existing account',
            stepTwo: 'step 2/3',
            helloWord: 'Hello',
            emailFieldLabel: 'My email',
            confirmEmailFieldLabel: 'Confirm my email',
            acceptWord: 'I accept the',
            cgu: 'general terms of use',
            cguBrackets: '(TOU)',
            corporateCommunicationByEmail: "I agree to receive by email communications and parent news to the company's departments",
            emailSend: 'You will receive an email to the address in a few moments',
            clickToFinalize: 'Click on the link in this email to finalize the creation of your Saur customer area.',
            inscriptionNotFinalizedError: 'An email for the creation of your customer area has already been sent to you at this address. This one, the subject of which is “finalization of your registration”, is active for 24 hours. If it does not appear in your inbox, remember to check your spam or “junk mail” box.'
        },
        stepThreeInThree: {
            expiredLink: 'This link has expired, please try again',
            sendMailAgainSuccess: 'Email sent successfully',
            linkActiveDuration: 'This link will be active for 24h',
            stepThree: 'step 3/3',
            confirmEmailFieldLabel: 'Confirm my email',
            success: 'Congratulations !',
            successCreationClientAccount: 'Your customer area has been created.',
            backToConnexion: 'Return to the login page'
        }
    },
    forgetPasswordScreen: {
        sessionError: 'Oops! Your session has expired, please try the procedure again.',
        stepEnterEmail: {
            title: 'Reset my password',
            titleOnTwoLine: 'Reset my password'
        },
        enterEmailToUpdate: {
            placeholder: 'My current email address',
            label: 'My username changes'
        },
        stepSendEmail: {
            title: 'Sent !',
            paragraphOnePartOne: 'If an account has been created with this email adress,',
            paragraphOnePartTwo: 'you will receive by email a link to reset your password.',
            paragraphTwo: 'Click on the link in this email to reset your password.',
            paragraphThree: 'This link is active 24h.',
            btnLabel: 'Return to login',
            notSendingEmail: {
                title: "Didn't receive an email?",
                linkLabel: 'Resend link'
            },
            forgetEmailLink: 'I no longer have access to my email address',
            errorMultipleChangeInYear: 'You cannot make more than two changes to your direct debit options over the past 12 months, please contact customer service to complete your request.',
            errorPendingAOtherDemande: 'You already have a request being processed, it will be effective within 72 hours.'
        },
        updatePasswordStep: {
            passwordFieldLabel: 'Choose my new password',
            confirmPasswordField: 'Confirm my new password'
        },
        updateSuccessStep: {
            title: 'Thank you !',
            content: 'Your password has been successfully changed.'
        },
        updateAdressStep: {
            title: 'Change my email address {brand}',
            emailValidation: 'Identifier to change : {mail}',
            QuestionBtnValidLabel: 'Yes',
            QuestionBtnNotValidLabel: 'No',
            textValidaton: 'I certify that I am the owner of the account attached to the email address {mail}.',
            btnValidation: 'Yes I certify it',
            failure: {
                btnLabel: 'Contact customer service',
                info: 'Without an invoice number or IBAN attached to this account, we unfortunately cannot complete your request for access to this account.'
            },
            enterEmailToUpdate: {
                placeholder: 'My old email address',
                label: 'My username to change'
            },
            questionHaveBilling: {
                question: 'Do you have an invoice less than 2 years old at your disposal?'
            },
            questionHaveDirectDebit: {
                question: 'Is the blocked account in direct debit?'
            },
            ibanInput: {
                info: 'Please enter the last 5 digits of the IBAN associated with this account',
                inputLabel: 'IBAN (last 5 digits)',
                inputPlaceholder: 'xx xx xxxxx xxxxx xxxxxx',
                inputPlaceholderNext: 'xxx xx',
                errorRequiredFiveNumber: 'The field must contain 5 digits'
            },
            billingNumberInput: {
                info: 'Please enter the number of an invoice dated less than 2 years',
                inputLabel: 'Bill number',
                inputPlaceholder: 'Enter your invoice number',
                linkInfoLabel: 'Where to find it?',
                errorRequiredTenNumber: 'The field must contain 12 digits'
            },
            newEmailInput: {
                info: 'Indicate with which address you will now identify yourself to access your {brand} customer area.',
                newEmailField: {
                    label: 'New e-mail address',
                    placeholder: 'Enter your new email address'
                },
                newEmailConfirmField: {
                    label: 'Confirm your email',
                    placeholder: 'Confirm your new email address'
                }
            },
            sendingEmail: {
                info_1: 'You will receive an email in a few moments at',
                info_2: 'Click on the link contained in this email to finalize the creation of your {brand} customer area.',
                info_3: 'This link is active 24h.',
                retry_1: "Haven't received an email?",
                retry_2: 'Resend link'
            }
        }
    },
    updateEmailSecondStepScreen: {
        sessionError: 'Oops! Your session has expired, please try the procedure again.',
        loaderTitle: 'Updating my email address',
        loaderMessage: 'Please wait ...',
        successCardTitle: 'Thank You !',
        successCardContent: 'Your Email Address have been reset',
        sucessCardBackButtonLabel: 'Return to login'
    },
    navigations: {
        forgetPassword: {
            label: 'Forgot your password',
            uri: 'forgot-your-password'
        },
        updateEmailValidation: {
            label: '',
            uri: 'EspacePublic/FinaliserIdentifiant.aspx'
        },
        login: {
            label: 'Login',
            uri: 'login'
        },
        createAccountFirstSteps: {
            label: 'Create Account',
            uri: 'create-account'
        },
        createAccountThirdStep: {
            label: 'Create Account',
            uri: 'EspacePublic/Inscription.aspx'
        },
        moveIn: {
            label: 'Subscription',
            uri: 'subscription'
        },
        cclAccess: {
            label: 'Attempting ccl Access',
            uri: 'ccl-access'
        },
        home: {
            label: 'Home',
            uri: 'home'
        },
        myContract: {
            label: 'My contract',
            uri: 'my-contract'
        },
        myPaiements: {
            label: 'My payments',
            uri: 'my-payments'
        },
        myProfile: {
            label: 'My profile',
            uri: 'my-profile'
        },
        myConsumption: {
            label: 'My consumption',
            uri: 'my-consumption'
        },
        myExchanges: {
            label: 'My exchanges',
            uri: 'my-exchanges'
        },
        helpAndContacts: {
            label: 'Help & contacts',
            uri: 'Help-and-Contacts'
        },
        cgu: {
            label: 'Terms',
            uri: 'general-condition-of-sale'
        },
        userData: {
            label: 'Personal data',
            uri: 'personal-data'
        },
        legalMentions: {
            label: 'Legal notice',
            uri: 'legal-notice'
        },
        contactUs: {
            label: 'Contact us',
            uri: 'contact-us'
        },
        paymentReturn: {
            label: 'Payment return',
            uri: 'payment-return'
        },
        updateEmailByBillingOrIban: {
            label: 'Update my email',
            uri: 'update-my-email'
        },
        mobileApp: {
            home: 'Home',
            contract: 'Contract',
            invoices: 'Payments',
            consumptions: 'Consu',
            exchanges: 'Exchanges'
        },
        deliveryPointRequestsTracking: {
            label: 'My Delivery Point Request Tracking',
            uri: 'delivery-point-request-tracking'
        },
        contactEmailValidation: {
            label: 'Validate Contact',
            uri: 'EspacePublic/validation-email-de-contact'
        },
        contractCancelation: {
            label: 'Contract Cancelation',
            uri: 'contract-cancelation'
        }
    },
    forms: {
        addContract: {
            clientReference: {
                placeholder: '10 digits reference',
                label: 'Client reference'
            },
            clientName: {
                oldPlaceholder: 'Your last name',
                placeholder: 'Your full name (as mentioned in the invoice)',
                oldLabel: 'Client last name',
                label: 'Doe John'
            },
            contractName: {
                placeholder: 'Ex : Home',
                label: 'Name your contract'
            },
            errorTryAgainLater: 'Please try again later.',
            referenceNameMatchingError: 'The contract search using these information did not yield any result. Please verify your contract information.',
            referenceUsedByAnotherAccountError: 'The specified reference is already associated to a Customer Area.',
            alreadyIncludedReferenceError: 'The specified reference is already associated to a Customer Area.',
            userNotFound: "An error related to the Customer Area occurred, please try again later.",
            clientHasNoActiveOrRecentlyTerminatedContracts: "The specified reference canno be added to your Customer Area as it does not contain any active or recently terminated contracts.",
            clientHasNoBillingAgreements: "The specified reference canno be added to your Customer Area as it''s a meter reading only Contract.",
            thanks: 'Thank you !',
            requestAck: 'Your request has been accepted.',
            contractAdded: 'Your new contract is now available in your client space.',
            addContractTitle: 'Add a contract',
            addContractButton: 'Add the contract',
            addContractButtonShort: 'Add',
            addContractDesc: 'You have another Saur contract,\nAdd it to your customer area and view\nall your contracts with ease.',
            defaultContractName: 'Home',
            addContractCancelButton: 'Cancel',
            closeErrorButton: 'Close',
            closeSuccessButton: 'Done',
            plzFillForm: 'Please fill out this form using the information located at the top right corner of you bill :'
        },
        updateAddress: {
            addressWord: 'Address',
            title: 'Change my billing address',
            headerCurrentAddress: 'Current address',
            formTitle: 'New billing address',
            success: {
                title: 'Thank You !',
                subtitle: 'The request regarding the modification of your billing address has been taken into account.',
                content: ' It will be reflected in your customer area within 48 hours.'
            },
            error: {
                title: 'OOPS !',
                unknowError: 'Your change of address request failed, please try again later.',
                wrongAddress: 'Your address is not valid, please try entering again.'
            },
            address: {
                label: 'N° and street',
                placeholder: 'Your address'
            },
            address2: {
                label: 'Complement',
                placeholder: 'Optional'
            },
            address3: {
                label: 'Place called',
                placeholder: 'Optional'
            },
            postalCode: {
                label: 'Postal code',
                placeholder: 'Your postal code',
                errors: {
                    unvalid: 'Postal code is not valid'
                }
            },
            city: {
                label: 'City',
                placeholder: 'Your city'
            },
            city2: {
                label: 'Cedex',
                placeholder: 'Optional'
            },
            country: {
                label: 'Country',
                placeholder: 'Optional'
            }
        },
        updateEmail: {
            noCurrentEmail: 'No email provided',
            title: 'Change my email address',
            headerCurrentPhone: 'Current email address',
            formTitle: 'New email address',
            success: {
                title: 'Thank You !',
                subtitle: 'The request regarding the modification of email has been taken into account.',
                content: 'An email has just been sent to your new address. Please click on the link to confirm the modification.'
            },
            error: {
                title: 'OUPS !',
                unknowError: 'Your request to change your email address has failed, please try again later.'
            },
            email: {
                label: 'New email address',
                placeholder: 'Your email address'
            },
            emailConfirm: {
                label: 'Confirm email address',
                placeholder: 'Your email address',
                errors: {
                    notEqual: 'Emails do not match'
                }
            }
        },
        updatePhone: {
            title: 'Change my phone number',
            noCurrentNumber: 'No phone number provided',
            headerCurrentPhone: 'Current phone number',
            formTitle: 'New phone number',
            success: {
                title: 'THANK YOU !',
                subtitle: 'The request regarding the modification of your phone number has been taken into account.',
                content: 'It will be reflected in your customer area within 48 hours.'
            },
            error: {
                title: 'OUPS !',
                unknowError: 'Your request to change your phone number has failed. Please try again later.'
            },
            phone: {
                label: 'Mobile phone number',
                placeholder: 'Your new mobile phone number'
            }
        },
        updateIban: {
            noCurrentIban: 'No IBAN provided',
            title: 'Change my bank information',
            headerCurrentIbanContract: 'Current IBAN',
            formTitle: 'New IBAN',
            contractLabel: 'My contract :',
            success: {
                title: 'THANK YOU !',
                subtitle: 'The request regarding the modification of your IBAN has been taken into account.',
                content: 'It will be available soon in your customer area.'
            },
            error: {
                title: 'OUPS !',
                unknowError: 'Your request to change your IBAN has failed, please try again later.'
            },
            iban: {
                label: 'IBAN',
                placeholder: 'Your IBAN'
            }
        },
        ccl: {
            title: 'Client last connection',
            email: {
                label: 'Client email address',
                placeholder: 'Client email address'
            },
            reference: {
                label: 'Client reference',
                placeholder: 'Client reference'
            },
            lastConnectionDate: 'Last connection date',
            creationDate: 'Creation date',
            error: {
                title: 'Client not found'
            }
        },
        updatePassword: {
            title: 'First connection',
            titleIndicator: 'to the new {brand} customer space',
            subtitle: 'Your password is not secure enough. Please change it to access your customer space.',
            oldUser: {
                title: 'Update your password',
                subtitle: 'In order to guarantee the security of your customer area, we are updating our password management tools, please enter a new password to access your area.'
            },
            currentPassword: {
                label: 'Current password',
                placeholder: 'My current password'
            },
            newPassword: {
                label: 'New Password',
                placeholder: 'New password',
                passwordIndication: 'The password must contain at least 8 characters including :',
                passwordIndicationSubtitle: '1 capital letter, 1 lowercase, 1 digit and 1 special character'
            },
            confirmNewPassword: {
                label: 'Confirm my new password',
                placeholder: 'My new password'
            }
        },
        email: {
            label: 'Username',
            placeholder: 'Your mail address'
        },
        password: {
            label: 'Password',
            placeholder: 'Your password'
        },
        iban: {
            label: 'Password',
            placeholder: 'Your IBAN',
            error: 'Incorrect IBAN format'
        },
        numberOfPeople: {
            label: 'Password',
            placeholder: 'Your IBAN',
            error: 'Incorrect IBAN format'
        },
        withdrawalDate: {
            label: 'Password',
            placeholder: 'Your IBAN',
            error: 'Incorrect IBAN format'
        },
        errors: {
            meterIdentifierInvalid: 'The meter identifier is not valid',
            errorCounterSerialSize: 'The meter identifier must contain 11 characters',
            phoneNotValid: 'The phone number typed is not valid',
            phoneNotMobile: 'The phone number typed is not a mobile phone',
            landlineNumberError: 'The phone number typed is not a landline phone number',
            emptyField: 'One of these fields is required',
            emptyRequiredField: 'This field is required',
            emailBadFormat: 'The mail format is incorrect: special characters (such as accents) are not accepted. In addition, your mail must not start with a dot.',
            emailBadLength: 'Email address entered is too long.',
            newPasswordNotSame: 'The confirmation does not match',
            passwordSecurityFailure: 'The password must contains at least 3 of 4 of those types: 1 uppercase letter, 1 lowercase letter, 1 digit, 1 special character',
            passwordSecurityFailureTwo: 'Your password does not respect the security rules',
            wrongCurrentPassword: 'Your current password is incorrect',
            emailAlreadyExistError: 'The email is already in use by another account',
            contractNameFormatError: 'The format of your contract name is incorrect',
            noAdressInfo: 'No address provided',
            amountToSmall: 'The amount of the withdrawal cannot be less than € {amount}',
            amountToHigh: 'The amount entered cannot exceed € 300',
            amountParamToHigh: 'The amount entered cannot be greater than {amount}€',
            amountToHighWarning: 'Warning: high monthly payment',
            amountEnteredTooHigh: 'Please note, the amount entered is higher than our estimate: this could lead to an adjustment at the end of the year',
            amountEnteredTooSmall: 'Please note, the amount entered is lower than our estimate: this could lead to an adjustment at the end of the year.',
            onlyDigit: 'The field must contain only numbers',
            nameBadLength: 'The input exceeds the maximum length.',
            fileSizeLimit: "The attachment's size exceeds the 10MB limit.",
            UserNot18OrOlder: 'You must be 18 years or older to be a contract holder.',
            UserOlderThan100: 'The date of birth entered is not consistent.',
            fileType: 'The format of the attachment is not accepted.',
            invalidEntryDate: 'The residence entry date is not valid.',
            matchingConfirmationFailure: 'The confirmation does not match',
            useSameEmail: 'Please enter an e-mail address different from that of the holder',
            notRoundedToNearestHalfEuro: 'The amount of the payment must be rounded to the nearest half euro, for example {amount}€.'
        },
        referenceClient: {
            placeholder: '0000000000'
        },
        userName: {
            oldPlaceholder: 'Dupont',
            placeholder: 'Doe John'
        },
        createAccountEmail: {
            label: 'My email',
            placeholder: 'jacques.dupont@email.com',
            formatError: 'The mail address format does not match',
            emptyError: 'This field is required'
        },
        createAccountEmailValidation: {
            label: 'My email confirmation',
            placeholder: 'jacques.dupont@email.com',
            notEqualError: 'The confirmation does not match',
            emptyError: 'This field is required'
        },
        createAccountAcceptCGU: {
            accept: 'I accept ',
            CGUFull: 'the terms of service ',
            CGUAbreviation: '(TOS)',
            error: 'This field is required'
        },
        createAccountAcceptSaurContact: {
            label: "I agree to receive by email communications and parent news to the company's departments"
        },
        updateContractName: {
            placeholder: 'Your new contract name',
            success: {
                title: 'THANK YOU !',
                subtitle: 'The request regarding the modification of your contract name has been taken into account.',
                content: 'Your customer area has been updated.'
            },
            error: {
                title: 'OUPS !',
                unknowError: 'Your request to change your contract name failed. Please try again later.'
            }
        }
    },
    api: {
        admin: {
            errors: {
                unknownError: 'The website is currently under maintenance. Please try again later.'
            }
        },
        auth: {
            errors: {
                unknownError: 'An unknown error has occurred',
                wrongIdentifiers: 'Your username and / or password is wrong',
                wrongPassword: "The provided password doesn't match your current password",
                identicPassword: "The new password can't be identical to your current one",
                invalidToken: 'The token is invalid',
                invalidDataToSend: 'The information provided is incorrect',
                unsuccessfulAction: 'This action came to an unsuccessful conclusion',
                contractTerminated: 'Your account has been terminated',
                alreadyValidated: 'The validation is already done'
            }
        }
    },
    invoice: {
        errorApi: {
            documentNotFound: 'Your bill will be available within 48 hours',
            documentExtensionNotSupported: 'This type of invoice cannot be viewed from your logged-in area.'
        },
        mySituation: {
            title: 'My situation',
            subTitle: 'Your account balance at {date}',
            payButtonLabel: 'Pay my balance',
            minimumLimitError: 'Your current balance is lower than the minimum required for credit card payment. Please proceed to the payment of this amount with your next invoice',
            terminatedContractLimitError: 'Your current balance is lower than the minimum required for credit card payment. please pay your balance by any other means'
        },
        titleCardEvent: 'My last bill',
        Screenheader: {
            myPayments: 'My payments',
            debits: 'Scheduled withdrawals',
            invoices: 'Bill',
            myservices: 'My Services'
        },
        ScreenLastInvoice: {
            cardTitle: 'My last invoice',
            invoiceNumber: 'Invoice n°',
            invoiceReference: 'Reference n°',
            issuedon: 'Emitted on',
            payedon: 'Payed on',
            payed: 'Payed',
            toSettle: 'To pay before ',
            consult: 'Consult',
            Download: 'Download',
            payeInvoice: 'Pay my bill',
            cardHistoryTitle: 'My invoices',
            history: 'My invoices history',
            next: 'See more',
            prev: 'See less',
            invoice: 'Invoice',
            relaunch: 'Relaunch letter',
            formalNotice: 'Formal notice'
        },
        ScreenAdvice: {
            adviceTitle: 'advices',
            adviceSubtitle: 'switch to direct debit',
            adviceSubtitle2: 'Switch to direct debit',
            freedom: 'Free your mind',
            rythme: 'Pay at your ease',
            asArises: 'Pay as arises',
            keepInvoices: "Don't lose any of your invoices",
            buttonText: 'Switch to direct debit',
            buttonTextMonthly: 'Switch to monthly payments'
        },
        ScreenServices: {
            title: 'My Services'
        },
        ServicesDebit: {
            title: 'Direct Debit',
            subtitle: 'Enabled',
            disabledSubtitle: 'Disabled'
        },
        downloadScreen: {
            back: 'Back',
            downloadDone: 'Invoice downloaded successfully !',
            downloadProofDone: 'Proof of residency downloaded successfully !',
            permission: 'Permission denied',
            error: 'Download error',
            pdf: '.pdf'
        },
        ServicesEBill: {
            title: 'e-invoice',
            activatedSince: 'Enabled',
            inactifService: 'Disabled service',
            activate: 'Enable',
            activateOption: {
                activateEBill: 'Activate electronic invoice',
                chooseElectronicInvoice: 'Activate Electronic Invoice',
                chooseElectronicInvoice2: 'Activate Electronic Invoice',
                adviceOne: 'You are notified by email for any new invoice',
                adviceTwo: 'You can access it online 24/7',
                adviceThree: 'You help reduce consumption of natural resources',
                activateOptionForFree: 'Activate the option for free',
                notInterested: 'I am not interested',
                validateBtnLabel: 'Validate my subscription'
            },
            activateDescription: {
                titleItsFast: "It's fast",
                descriptionItsFast: 'You will be notified by email of the availability of any new invoice',
                titleItsEasy: "It's easy",
                descriptionItsEasy: 'You can access your invoices online 24/7 in your customer space',
                titleItsConvenient: "It's convenient",
                descriptionItsConvenient: 'Invoices are kept for 5 years in your customer space',
                titleItsGreen: "It's ecological",
                descriptionItsGreen: 'You help reduce the consumption of natural resources',
                titleItsFree: "It's free",
                descriptionItsFree: 'You can cancel at any time'
            },
            activateOptionSuccess: {
                title: 'Your request has been taken into account !',
                amountCharged: 'Amount withdrawn',
                frequency: 'month',
                directDebitActivation: 'Activating the direct debit',
                electronicInvoiceActivation: 'Activating the electronic invoice',
                descriptionPartOne: 'You will soon receive a SEPA mandate to return to us as soon as possible.',
                descriptionPartTwo: 'An email will be sent to you when a customer advisor has taken your request into account',
                goToPaymentDashboardBtnLabel: 'Access my « payments »  view',
                electronicInvoiceSoonReady: 'Your electronic invoices will soon be available in your space',
                calendarSoonReady: 'Your payment schedule will be available within 24 hours from your customer area under the heading my payments.',
                signSepaMadate: 'Sign my SEPA mandate'
            },
            terminateEbillService: {
                terminateOption: 'Deactivate',
                terminateEbillModal: {
                    title: 'Deactivate electronic invoice',
                    content1: 'You are about to deactivate electronic invoice.',
                    content2: "Once it is done, you won't be able to access your previous invoices records in your customer area. Only your last duplicate invoice will be displayed.",
                    content3: 'At any time, you can reactivate this option.',
                    terminateCta: 'Deactivate',
                    cancelTerminationLink: 'Keep electronic invoice',
                    terminateEbillServiceSuccess: {
                        title: 'Electronic invoice deactivated',
                        content: 'At any time, you can reactivate this option by activating the service.',
                        terminateCta: 'Terminate'
                    }
                }
            }
        },
        HowItWorks: {
            title: 'How does it work ?',
            stepOneCompleteYourInfoTitle: 'Write your information',
            stepOneCompleteYourInfoDesc: 'IBAN et estimation de consommation',
            stepOneCompleteYourInfoV2DescEstimatbale: 'IBAN and monthly payment',
            stepOneCompleteYourInfoV2DescNotEstimatbale: 'Enter your IBAN',
            stepTwoChoseDateTitle: 'IBAN and consumption estimate',
            stepTwoChoseDateDesc: 'Vous serez prélevé le jour choisi tous les mois',
            stepThreeSendSepaTitle: 'You will be debited on the chosen day every month',
            stepThreeSendSepaDesc: 'By post or email',
            stepThreeDesc: 'Your request will be processed by a customer advisor',
            stepFourTitle: '24h registration',
            stepFourDesc: 'Upon receipt of your signed mandate',
            warningTitle: 'INFORMATION',
            warningMessage: 'during the billing period, the first withdrawal will only take place after your next invoice has been issued',
            warningMessageFull: 'INFORMATION : during the billing period, the first withdrawal will only take place after your next invoice has been issued',
            subscriptionBtnLabel: 'Subscribe to direct debit',
            subscriptionBtnLabelV2: 'Subscribe to monthly payments'
        },
        SubscribeToDebit: {
            title: 'Subscribe to direct debit',
            titleV2: 'Subscribe to monthly direct debit',
            yourIban: 'Indicate your IBAN',
            correctIfIncorrect: 'To correct if incorrect',
            numberOfPeopleTitle: 'Indicate the number of people living in your household',
            chooseDebitDateTitle: 'Choose your monthly direct debit day',
            estimatedInvoiceLabel: 'Estimate of your invoice',
            estimatedInvoiceDesc: 'This indicative amount will be adjusted according to the actual price applied in your municipality. A summary of future monthly payments will be sent to you by Customer Service.',
            chooseDebitPlaceholder: 'To choose',
            validateMySubscription: 'Validate my subscription',
            chooseDebitDescPartOne: 'You will be charged each',
            chooseDebitDescPartTwo: 'of the month',
            estimatedAmountLabel: 'Estimate of the amount of my billing',
            estimatedAmountLabelMonthly: 'Estimation of my monthly payment',
            paymentPerYear: '/year',
            paymentPerMonth: '/month',
            paymentPerSemester: '/semester',
            estimatedNoticeAmountLabel: '* estimate is based on billed consumption last year.',
            estimatedNoticeAmountSemesterLabel: '* estimate is based on billed consumption last semester.',
            myIbanLabel: 'my IBAN',
            myIbanDescription: 'I can type it or update it',
            monthlyPaymentLabel: 'I would like to be debited for',
            monthlyPaymentLabelNoEstimate: 'I would like to be debited every',
            monthlyPaymentDescription: 'I can change the amount of the proposed monthly payment',
            debitDaysLabelPart1: 'every',
            debitDaysLabelPart2: 'of the month',
            chooseDebitPlaceholderV2: '1-15'
        },
        SubscribeToDebitAtMaturity: {
            title: 'Subscribe to direct debit at maturity',
            proposition: 'Do you prefer to be debited 15 days after issuing your invoice ?',
            chooseQuestion: 'Choose the',
            directDebitMaturity: 'direct debit maturity',
            directDebitMaturity2: 'Direct debit maturity',
            requestRegistered: 'Your request has been taken into account.',
            debitedInformation: 'You will be charged 15 days after issuing your invoice.',
            nextDebit: 'Next invoice',
            goToPayments: 'Discover my new « payments » area',
            confirmationActivation: 'Activating the debit at maturity'
        }
    },
    contract: {
        myContracts: 'My contracts',
        chooseContract: 'Choose one contract',
        contracts: 'Contracts',
        actions: {
            remove: 'Remove',
            select: 'Choose',
            cancel: 'Terminate',
            add: 'Add',
            rename: 'Rename',
            download: 'Download',
            modify: 'Update'
        },
        deliveryInfos: {
            delivery: 'Delivery point',
            deliveryType: 'Type',
            techInfos: 'Technical information',
            statedOn: 'Stated on',
            meterNumber: 'Meter reference number',
            diameter: 'Diameter',
            brand: 'Brand',
            location: 'Location',
            installationDate: 'Installation date',
            chooseDelivery: 'Choose a delivery point'
        },
        contractInfos: {
            contractRefClient: 'Customer reference',
            rename: 'Rename',
            addContractButton: 'Associate a contract',
            removeContractButton: 'Terminate a contract',
            downloadContractButton: 'Download a receipt',
            documentName: 'Proof of residency',
            contractNumberTitle: 'Contract reference',
            contractStartDate: 'Started on',
            contractModifyButton: 'Update my contract',
            noContract: 'No contract available',
            renameContractModal: {
                title: 'Modify the contract name',
                currentContractName: 'Current contract name',
                newContractName: 'New contract name'
            }
        },
        multiContract: {
            selectContract: 'Select a contract'
        },
        chooseContractModal: {
            title: 'Select one contract',
            customerRef: 'Customer reference {reference}',
            resiliatedAt: 'Terminated at {date}',
            delay: 'It will be reflected in your customer area within 24 hours.',
            customerAccountRef: 'Customer account reference : ',
            contractIndex: 'Contract {index}'
        },
        cancelContract: {
            title: 'Cancel a contract',
            cancelMyContract: 'Cancel my contract',
            descModalTitle: 'You are moving and you want to cancel your subscription.',
            descModalSubtitle: 'It is important that our technician intervenes to close your connection. This intervention secures the installation. You can leave the accommodation with complete peace of mind.',
            desModal: 'If your meter is inside your home, contact us to make an appointment.',
            desModalInd: 'If your meter is accessible, all you need to do is:',
            firstInd: 'Read your meter',
            secondInd: 'Report the statement corresponding to m3 on this form',
            thirdInd: 'Tell us your new address',
            deadlineVld: 'We will send you the invoice clearing your account as soon as possible.',
            pendingRequestText1: 'A termination request is already being processed.',
            pendingRequestText2: 'This will be processed shortly.',
            validationBtn: 'I get it',
            meterReading: 'Meter reading',
            meterNumber: 'Number of your meter',
            readingDate: 'Date of succession',
            redingDatePlaceholder: 'Date prior to or equal to today',
            readingDateInput: 'Report the 4 to 6 digits indicated on your meter',
            newAdresse: 'New address',
            currentDeliveryPointAddress: 'Meter address',
            confirmation: 'Confirmation',
            confirmationInd: 'You are about to cancel your subscription, please double check your information before validating.',
            modifyInput: 'Modify my entry',
            confirmationCancelContract: 'Confirm my termination',
            contractCanceled: 'Your connection will soon be terminated and you will receive the invoice clearing your account as soon as possible, at your new address.',
            delayTerminatedContract: 'It will be reflected in your customer area within 48 hours.'
        },
        removeContract: {
            title: 'Remove this contract',
            message: 'You are about to remove the following contract with all of its subscriptions. Please verify the information before clicking on the "Remove" button. If you wish to add this contract later, you will only need to use the “Add a contract” function in “My Contract” page.',
            warning: 'The sections subscriptions linked to this contract will be removed from concerned families.',
            button: 'Remove this contract',
            selectNewContract: 'Please select a contract. The last selected contract was deleted',
            selectNewContractFamily: 'Please select a contract, or a family. The last selected contract or family, was deleted',
            confirmationMsg: 'Your request has been processed'
        }
    },
    updateAppModal: {
        title: 'ONE MINUTE !',
        info: 'A new version of the application is available.',
        instruction: 'Please download it to continue on the app.',
        btnActionLabel: 'Download the update'
    },
    maintenanceScreen: {
        title: 'OUPS ...',
        info: 'App maintenance',
        instruction: 'You will be able to reconnect very soon. Please excuse us for this setback.',
        btnActionLabel: 'Close the app'
    },
    consumption: {
        from: 'From',
        to: 'to',
        fromDate: 'From',
        first: 'st',
        second: 'nd',
        thrid: 'rd',
        fourthAndMore: 'th',
        toDate: 'to',
        nextBtnAlt: 'Next',
        prevBtnAlt: 'Previous',
        backBtnAlt: 'Back',
        onHover: 'on',
        year: 'Year',
        month: 'Month',
        week: 'Week',
        title: 'MY CONSUMPTION',
        tipsBtnLabel: '{brand} advises you',
        currentYearMessage: 'Over the year',
        currentMonthMessage: 'Over the month of',
        currentWeekMessage: ' Over the week ',
        yearsIntervalMessageDebut: 'over the last',
        yearsIntervalMessageEnd: 'years',
        oneYearIntervalMessage: 'over the last year',
        loading: 'Loading data ...',
        apiError: 'An error occured while fetching data',
        noDataToDisplay: 'No data to display',
        details: 'See details',
        exportConsumption: 'Export family data',
        estimateConsumptionMessage: 'The remote reading module of one of your connections is malfunctioning, consumption is therefore estimated',
        real: 'Real',
        estimate: 'Estimate',
        global: 'Global'
    },
    payment: {
        nextPayment: 'Next withdrawal',
        seeDetailsNextPayment: 'See the details of my next direct debit (new tab)',
        paymentSuccess: 'Your transaction has been registered. Your account on the client space will be updated within 48 hours.',
        paymentCancelled: 'Your payment request has been cancelled.',
        paymentRefused: 'Your payment has been disapproved by your financial institution. Unfortunately, we cannot grant your request',
        errors: {
            noPayment: 'Your payment has already been processed. You client space will be updated within 48 hours.',
            clientCutOff: 'Your current account situation does not allow you to pay from our website. Please contact the customer services',
            contactUs: 'Please contact our service customer.'
        },
        paymentSuccessMobile: 'Your payment was successful',
        paymentSuccessSubtitle: 'Your balance is settled!',
        paymentSuccessMailMessage: 'A confirmation email will be sent',
        paymentSuccessBackButton: 'Go back to my invoices',
        paymentHistory: {
            cardFull: {
                cardFullTitle: 'My Next Withdrawal',
                cardFullDatePicked: 'Debited the ',
                carfFullBtnLabel: 'Modify my direct debit'
            },
            list: {
                listTitle: 'My Withdrawals',
                listSubTitle: 'Monthly payment calendar',
                oldDebit: 'Previous withdrawal ',
                nextDebit: 'Next withdrawal ',
                nextDebit2: 'Next withdrawal ',
                futurDebit: 'Future withdrawal '
            },
            updateDebitOptionModal: {
                inputsForm: {
                    label_1: 'I would like to be charged',
                    label_2: 'every',
                    label_3: 'of the month',
                    AmountPlaceholder: '35€',
                    dayPlaceholder: '1 - 15'
                },
                successPage: {
                    title: 'Direct debit changed!',
                    willBeDisplayedShortly: 'Your request has been taken into account and will be soon visible in your customer area',
                    debitDateDescription: 'on the ',
                    debitAmountDescription: 'You will be debited',
                    debitUpdateMonthOnly: 'each month',
                    debitUpdateMonth: 'each month from',
                    desc: 'Your request has been taken into account and will be visible within 72 hours in your customer area'
                }
            }
        }
    },
    exchanges: {
        title: 'My exchanges',
        noExchangeTitle: "You don't have yet\nexchanges with Saur",
        noExchangeMessage: 'Find in this section all your requests and answers provided by Saur.',
        sectionWorkOrderTitle: 'FOLLOW-UP OF MY INTERVENTIONS',
        requestSection: {
            requests: 'Requests',
            title: 'My requests',
            historicLabel: 'View my request history',
            actionLabel: 'New request',
            emptyRequest: 'No Requests',
            showRequestsPage: {
                informationTooltip: 'We display requests from the last 3 years only',
                processingClaimsLink: 'Consult request processing commitments',
                showMoreRquests: 'Show more requests',
                since: 'Since',
                status: {
                    Received: 'Received',
                    Closed: 'Closed',
                    InProgress: 'In progress'
                }
            }
        },
        interventionSection: {
            interventions: 'Interventions',
            title: 'Interventions at my home',
            historicLabel: 'See the intervention history',
            emptyIntervention: 'No intervention carried out or being planned at your supply point'
        },
        alerts: 'My alerts',
        configTitle: 'All alerts',
        alertsTypes: 'Alerts settings',
        lastAlerts: 'My last alerts',
        successMessage: 'Your request is taken into account',
        failureMessage: 'Your request is not taken into account',
        informativeMessage: 'New features coming soon: \n -Detection of a residual leak at low flow rate \n -Monitoring of your consumption during your absences \n -Notification of your overconsumption alerts to several recipients of your choice',
        noAlerts: 'You have no alerts at the moment',
        overconsumingAlertsSection: {
            alerts: 'Alerts',
            title: 'My overconsuming alerts',
            emptyAlert: 'No overconsuming alerts',
            timeRange: 'From {start} to {end}',
            timeRangeStartDayOnly: 'Since {start}',
            alertBoxTitle: 'Unusually high consumption : over {qty}L per day during at least {duration} day(s) in a row.',
            emailNotification: 'Email notification sent to {email}',
            phoneNotification: 'SMS notification sent to {phone}',
            emptyNotification: 'No notifications',
            overConsumptionAlert: 'Overconsumption alert',
            overConsumptionAlertThreshold: 'Overconsumption alert threshold',
            liter: 'liters',
            edit: 'edit',
            chooseThresholdLabel: 'Choose a threshold',
            editThreshold: 'Edit the threshold',
            alwaysOn: 'Always ON',
            alertDetail: 'Alert detail',
            alertDetailMessage: 'You will be alerted if your consumption has exceeded the threshold set here',
            alertDetailMessageApp: 'You will be alerted if your consumption has exceeded the threshold set here per day for {duration} day(s)',
            duration: 'Overconsumption duration',
            day: 'day(s)',
            validate: 'Validate',
            unauthorizedVolumeThreshold: 'Your threshold has already been modified by a customer advisor, please contact your customer advisor',
            type: 'Overconsumption'
        },
        residualLeakAlertsSection: {
            alertName: 'Residual leak alert',
            alertMessage: 'Activate the residual leak alert and receive a notification by e-mail and/or SMS if a water consumption is recorded over 24 hours continuously',
            residualLeakInformation: 'Continuous consumption over 24 hours',
            information: 'infos',
            activated: 'Actived',
            disabled: 'disable',
            type: 'Residual leak'
        },
        traquilityAlertSection: {
            alertName: 'Tranquility alert',
            alertMessage: 'Activate the tranquility alert and receive a notification by e-mail/SMS when a water consumption is detected in your absence',
            tranquilityInformation: 'Consumption of {value} liters detected',
            tranquilityAlertMessage: 'Define a period of absence and be alerted if I have a consumption',
            activated: 'Actived',
            disabled: 'Disabled',
            type: 'Tranquility',
            slotDateMessage: 'The {date}'
        },
        interventionItemSection: {
            planInterButton: 'Plan',
            modifyInterButton: 'Edit',
            cancelInterButton: 'Cancel',
            interToBePlanned: 'Intervention to be planed',
            EditPopupSection: {
                title: 'Edit or cancel my appointment',
                message: 'Those functionalities are not yet available in your customer area. Please call customer service to edit or cancel your appointment.'
            }
        },
        interventionRDVSection: {
            Address: 'Address',
            MeterID: 'Meter number',
            Slot: 'Slot',
            Info: 'Appointment info',
            infoRdv1Part1: 'An agent will arrive at the location during the selected time slot.',
            infoRdv1Part2: 'The agent will not call you to confirm his arrival.',
            infoRdv2: 'In case of unavailability, you have until the day before to modify or cancel the appointment. In case of absence, if the appointment has not been cancelled by you, you will be charged for the intervention.',
            LangDate: 'en-US',
            appointmentReason: 'Reason for the appointment',
            phoneNumber: 'Contact number',
            moreInfo: 'Additional information'
        },
        appointment: {
            title: 'Plan an intervention',
            interventionType: {
                MeterRenew: 'Meter Renew'
            },
            stepper: {
                InterventionType: 'Type',
                AppointmentDate: 'Date',
                ClientInformation: 'Information',
                Recap: 'Summary'
            },
            intervetionTypeStep: {
                interventionType: {
                    label: 'Intervention Type',
                    placeholder: 'Pick an intervention type'
                }
            },
            informationStep: {
                phoneLabel1: 'Please check your contact cell phone number.',
                phoneLabel2: 'The phone number entered will be updated on your customer profile.',
                extraInformationLabel: 'If needed, please enter additional information for the agent.',
                extraInformationPlaceholder: 'Ex: other phone number for this intervention',
                phonePlaceholder: 'My cell phone number'
            },
            interventionCalendarStep: {
                noSlotsFoundMsg: 'No time slot is available for the next 15 days. Please retry later'
            },
            appointmentPickStep: {
                lastAvailableDay: 'The next days are not yet available.'
            },
            success: {
                thankYou: 'THANK YOU !',
                rdvSuccess: 'Your appointment is scheduled.',
                successPart1: 'In case of unavailability, you have until the day before the possibility of modifying or cancelling the appointment made in the follow-up of the interventions in the heading « My exchanges ».',
                successPart2: 'In case of absence, if the appointment has not been cancelled by you, you will be charged for the intervention.',
                closeButton: 'Finish'
            },
            failure: {
                closeButton: 'Close',
                errorMessage: 'AN ERROR HAS OCCURRED',
                errorDescriptionMessage: 'A technical problem prevented the validation of your request.'
            },
            unauthorizedEditOrCancel: {
                title: 'Change or cancel my appointment is impossible',
                description: 'You can no longer change or cancel your appointment less than 24 hours before the intervention. Please contact your customer service.'
            },
            cancel: {
                recap: {
                    title: 'Cancel my appointment',
                    message1: 'You are about to cancel the next scheduled intervention:',
                    message2: 'Once cancelled, you will have to click on the button " plan " again in order to be able to make an appointment for a new intervention.',
                    confirmButton: 'Cancel my intervention'
                },
                success: {
                    title: 'Your appointment has been cancelled.',
                    message1: 'In order for your intervention to take place, a new appointment must be scheduled.',
                    message2: 'To do so, you will have to click again on the « schedule » button in order to make an appointment for a new intervention.',
                    confirmButton: 'Finish'
                }
            },
            conflict: "We're sorry, but the time slot you selected is no longer available. Please select a new one.",
            loadingSlots: 'Please wait, we are currently looking for available slots ...',
            loadingBooking: 'Please wait, while we are confirming your appointment',
            nextBtnAlt: 'Next',
            prevBtnAlt: 'Previous',
            validateBtnAlt: 'Validate'
        },
        multiRecipients: {
            title: 'WHO RECEIVES MY ALERTS?',
            firstParagraph: 'Here you can configure the email addresses that will receive your alerts. \n You can also add a phone number.',
            secondParagraph: 'Without additional address provided, only the customer area holder can receive the alerts: {email}',
            titleAdressesForm: 'Additional addresses',
            titlePhoneForm: 'Sending by SMS',
            submitForm: 'Validate changes',
            phone: 'Phone number',
            emailAdresse2: 'Mail address 1',
            emailAdresse3: 'Mail address 2',
            emailAdresse4: 'Mail address 3',
            titleSuccess: 'Your addresses have been updated successfully.',
            firstParagraphSuccess: 'A message has been sent to the addresses and numbers provided.',
            secondParagraphSuccess: 'Validation from them is necessary to receive alerts.',
            submitSuccess: 'Close',
            titleFailure: 'Unable to change email address.',
            firstParagraphFailure: 'You can no longer change your email address.',
            secondParagraphFailure: 'Please contact your customer service.',
            submitFailure: 'Close',
            emailError: 'You have already used this email address',
            validatedMessageTooltip: 'Validated and active (this address is used to send alerts',
            pendingMessageTooltip: 'An email has been sent to your contact, they have 48 hours to validate this email',
            expiredMessageTooltip: 'The email has not been validated for the co-recipient, please send it back or enter another address',
            validatedMessage: 'Activated',
            pendingMessage: 'Awaiting validation',
            expiredMessage: 'Not validated',
            informativeMessage: 'Validation emails will be sent as soon as you validate the changes.',
            titleSuccessWithAdresses: 'Your addresses {emails} have been updated successfully.',
            failedEmailMessage: 'We were unable to send the validation email to {contact}, an unknown error occurred. Please try again.',
            failedPhoneMessage: 'We were unable to send the validation SMS to {contact}, an unknown error occurred. Please try again.'
        },
        validateAlertContact: {
            titleSuccess: 'You have been successfully added as a co-recipient',
            firstParagraphSuccess: 'Thank you for your validation.',
            titleFailure: 'We cannot add you as a co-recipient',
            firstParagraphFailure: 'The link you used expires after 48 hours.',
            secondParagraphFailure: 'The applicant has the possibility to resend you a request through their internet space.',
            alreadyAddedAsCoReceiver: 'You have already been added as a co-recipient',
            alertCoReceiver: 'If an alert occurs for the requester, you will be contacted as a co-recipient.'
        }
    },
    articles: {
        title: '{brand} advises you',
        details: 'See more'
    },
    HelpContactsScreen: {
        receptionCenter: 'Reception center',
        receptionCenterTitle: 'Meet us',
        receptionCenterDesc: 'Find the dedicated {brand} reception point dedicated to you as well as our telephone numbers',
        receptionRedirection: 'Find my reception center',
        makeArequestLink: 'Make a request',
        makeArequestCardTitle: 'Contact Us',
        makeArequestCardDescription: 'Send us your requests, we will answer your questions as soon as possible',
        SemMakeArequestCardDescription: 'Contact us by email or make an appointment directly with an adviser at a reception point or by phone',
        eligibilityMessage: 'Your last request is being processed by your customer advisor'
    },
    userinformation: {
        UnknownAddress: 'My address is not listed',
        myProfile: 'MY PROFILE',
        myContract: 'My contract',
        email: 'Email',
        phone: 'Phone number',
        billingAdress: 'Billing address',
        bankInformation: 'Bank information',
        newsletter: 'Newsletter',
        newsletterAgree: 'I agree to receive communications from {brand} by',
        newsletterAgreeEmail: 'email',
        newsletterAgreeSms: 'sms',
        disconnect: 'Disconnect',
        expiredSession: {
            title: 'Session expired',
            message: 'You have been disconnected because your session has expired.'
        },
        deleteAccountText: "You don't want to access to your {brand} client space anymore ?",
        deleteAccountLink: 'Delete my {brand} account'
    },
    updateEmail: {
        screenTitle: 'Edit my email',
        currentEmail: 'Current email',
        newEmail: 'New email',
        confirmNewEmail: 'Confirm email',
        yourEmailPlaceHolder: 'Your email',
        register: 'Save',
        successThankYou: 'Thank you!',
        successTitle: 'Your request has been registered',
        successMessage: 'An email has just been sent to your new email address. Please click on the link to confirm the modification.',
        sucessFinish: 'Finish'
    },
    updateIban: {
        screenTitle: 'Change my bank details',
        invalidIban: 'The IBAN is not valid. Please check your entry.',
        updateIsPending: 'We have already received your IBAN change request: the update will be visible in your online space within 72 hours.',
        myContract: 'My contract',
        currentIban: 'Current IBAN',
        newIban: 'New IBAN',
        yourIban: 'Your IBAN',
        register: 'Register',
        successThankYou: 'Thank you!',
        successTitle: 'Your IBAN has been updated',
        successMessage: 'Your request to change the IBAN will be taken into account soon and will soon be available in your customer area.'
    },
    common: {
        serviceUnavailable: 'The service is currently unavailable. Please try again in 24h',
        errorGetData: 'Error retrieving your data',
        seeDetails: 'See details',
        currency: '€',
        valid: 'Validate',
        cancel: 'Cancel',
        floatingPoint: '.',
        waterMeasuringUnit: 'm³',
        welcome: 'Welcome',
        copyRight: '© {brand} Customer Service - All rights reserved',
        clientArea: 'Client area',
        goToProfile: 'Access my profile',
        noDataToBeDisplayed: 'No data available',
        save: 'Save',
        wrongFormat: 'Incorrect format',
        wrongReferenceClientFormat: 'The submitted customer reference client is not valid',
        identificationDenied: 'We could not identify you',
        update: 'Update',
        loadingFetchingData: 'Please wait ...',
        errorFetchingData: 'An error has occurred, please try again later',
        loading: 'Loading',
        errorLoading: 'Loading Error',
        oups: 'Oups ...',
        ok: 'OK',
        at: 'at',
        and: 'and',
        between: 'between',
        close: 'close',
        home: 'Home',
        wrongStatusAtCreation: 'An error occurred in the creation of your customer area.\nWe thank you for contacting your customer service, mentioning the following error code: X01',
        wrongStatusAtAddition: 'An error occurred when you added a customer reference to your space.\nWe thank you for contacting your customer service, mentioning the following error code: X02',
        wafBlockingError: 'An error related to our security policy has occurred.\nWe thank you for contacting your customer service, mentioning the following error code: X03',
        network502Error: 'The service is temporarily unavailable (code 502), please try again later',
        network503Error: 'The service is temporarily unavailable (code 503), please try again later',
        network504Error: 'The service is temporarily unavailable (code 504), please try again later'
    },
    lastMeter: {
        title: 'Last meter reading'
    },
    modal: {
        buttonCommmunicate: 'Pass my statement',
        lastMeter: 'Last statement update on',
        instructionLine1: 'Report 4 to 6 numbers',
        instructionLine2: 'indicated on your meter',
        buttonValidate: 'Validate',
        indicationTitle: 'My meter',
        matricule: 'Meter number',
        indicationHelp: 'Where can I find those numbers?',
        indicationDescriptionPart1: "In the cell « Meter's statement », ",
        indicationDescriptionPart2: 'report only 4 to 6 digits in white on black or in black on white',
        indicationDescriptionPart3: '. They constitute the statement that you will see on your invoice stated in m³ (1 m³=1000 l)',
        indicationDescription: "In the cell « Meter's statement », report only 4 to 6 digits in white on black or in black on white. They constitute the statement that you will see on your invoice stated in m³ (1 m³=1000 l)",
        indicationDescription2: 'Please report the black numbers on your meter',
        lastCounterNumber: 'Last statement',
        numberToReportinm3: 'Number to report in m³',
        svgCounterFigure: {
            lastReport: 'Last statement',
            volume: 'Volume',
            inLitre: 'in liters',
            numbres: 'Numbers',
            toReport: 'to report',
            volumeIn: 'Volume in',
            m3: 'm³'
        },
        levelInLiters: 'Level in liters',
        buttonBack: 'Back to statement',
        addressTitle: 'Meter address',
        newMeter: 'New statement',
        newMeterTitle: 'New meter statement',
        changeInput: 'Change my input',
        greetings: 'Thanks !',
        successMessage: 'Your statement has been successfully sent',
        successLine1: "Your meter's information",
        successLine2: 'will be updated soon',
        buttonFinish: 'End',
        errorMessage: 'Sending error',
        errorDesc: 'You may try later',
        inputLengthError: 'Statement must contains at least 4 digits',
        inputMeterError: 'Statement smaller than last',
        pictureModal: {
            pictureExtensionAlertTitle: 'Photo of the water meter',
            pictureExtensionAlertMessage: 'The type of photo chosen is not allowed. Choose another photo in JPEG JPG format.',
            permissionAlertTitle: 'Water meter reading',
            permissionAlertMessage: "To make sending a photo easier, Saur wants to access your camera and your library. \nYou can change your preferences at any time by clicking on 'Preferences' in the application settings.",
            info: 'Impossible d’importer votre photo de compteur. Essayer de nouveau ou de continuer sans.',
            takeButton: 'Take a picture',
            importButton: 'Attach a picture',
            withoutButton: 'Continue without picture',
            modifyPicture: 'Change picture',
            validateStatement: 'Validate reading',
            addPictureButton: 'Add a picture',
            preferences: 'Preferences',
            takePictureOrJoinFileModalTitle: 'Take a photo of your meter or attach a photo of your meter to the new statement.'
        },
        indexEntryBlockMessage: 'Your index entry is being processed, you must wait at least 48 hours between two index entries.'
    },
    unsubscribe: {
        firstStep: {
            title1: 'Unsubscribe from the {brand} customer area',
            title2: 'You are about to permanently delete your {brand} account.',
            description1: 'You will no longer be able to access features related to your water consumption.',
            description2: 'Deleting your customer area does not imply the termination of one or more contracts with {brand}.',
            confirmationCheckbox: 'I confirm that I no longer wish to have access to my customer area, nor to receive information on {brand} services.',
            confirmButton: 'Validate'
        },
        secondStep: {
            title: 'Thank you !',
            description1: 'Your request has been taken into account.',
            description2: 'Your account will be deleted within 24 hours, you will be redirected to the customer area authentication page.',
            closeButton: 'Done'
        },
        errorStep: {
            errorMessage: 'AN ERROR HAS OCCURRED',
            errorDescriptionMessage: 'A technical problem prevented the validation of your request.',
            tryAgainMessage: 'Please, try again later.',
            cancelButton: 'Close'
        }
    },
    sem: {
        family: {
            connections: 'Delivery points',
            allConnections: 'All Delivery points',
            searchFamily: 'Search family',
            addFamily: 'Add family',
            family: 'family',
            telereleve: 'remote reading',
            nonTelereleve: 'not remote reading',
            families: 'Families',
            cancelButton: 'Cancel',
            noFamilyExistsMessage: 'There are no families in your account',
            delete: {
                title: 'Delete family',
                message: 'Would you like to delete « {family} » ?',
                warning: 'If you delete this family, you unlink all branches to this family. Branches retain their other associations.',
                button: 'Delete'
            },
            sectionSubscription: {
                rename: {
                    title: 'Rename section subscription',
                    Name: 'Name',
                    button: 'Rename',
                    errorMessage: {
                        required: 'This field is required',
                        maxLength: 'The name must contain less than 50 characters.',
                        minLength: 'The name must contain more than 3 characters.',
                        alreadyExists: 'There is already a section subscription with this name.'
                    }
                }
            },
            familyCreation: {
                createFamily: 'CREATE A FAMILY',
                familyName: 'Family name',
                findDelivery: 'Find connection',
                createFamilyButton: 'Create the family',
                noSecSubFound: 'No section subscription found'
            },
            updateFamily: {
                updateFamily: 'UPDATE A FAMILY',
                updateFamilyButton: 'Update the family'
            },
            errorMessages: {
                familyNameErrorMsg1: 'The family name must contain more than 3 characters and less than 50 characters.',
                familyNameErrorMsg2: 'There is already a family with this name.',
                familySectionSubscriptionErrorMsg1: 'Please select at least one connection.',
                familySectionSubscriptionErrorMsg2: 'A family cannot have more than one branch type.',
                createFamilyCondition: 'The family must contain at least one connection. If you want to ungroup all connections, please delete this family.'
            }
        }
    },
    coachConso: {
        neighborComparison: {
            widgetTitle: 'Comparison to similar homes',
            smileyTitle: 'Your Consumption is',
            legendTitle: 'Who Are Similar Households?',
            waterLabel: 'Water',
            consumptionTitle: 'You used 120% more water than similar households',
            chartsYouLabel: 'You',
            chartsEfficientLabel: 'Efficient Homes',
            chartsAverageLabel: 'Average Households',
            smileysGreatText: 'Excellent',
            smileysGoodText: 'Good',
            smileysAverageGreatText: 'Higher than average',
            legendFoyersEfficacesTitle: 'Efficient Homes',
            legendFoyersEfficacesDescription: 'Top 20% of similar homes in your area with {{occupancy}} occupants',
            legendFoyersMoyensTitle: 'Average Households',
            legendFoyersMoyensDescription: 'The average use of similar dwellings in your area that has {{occupancy}} occupants',
            unit: 'cubic meter'
        },
        disaggregation: {
            widgetTitle: 'Comparison to similar homes',
            title: 'Your household average water use'
        },
        survey: {
            updateMyData: 'Update My Household',
            neibhorComparisonInfo: 'This comparison is based on information we have about your household',
            waterUseInfo: 'This is your average usage in your household. We have disclosed your usage from various sources. To refine this estimate, please complete your household profile.',
            updateMyDataButton: 'Update My Household',
            language: {
                progressBarTextFirstPart: 'You have answered ',
                progressBarTextSecondPart: 'question(s) out of',
                privacy_note: '',
                updateButton: 'Update my information',
                pleaseSelect: 'Please select a value',
                alerts: {
                    success: 'Answers submitted successfully',
                    failed: 'Unable to submit your answers',
                    upToDate: 'Answers are up to date'
                }
            },
            errorMessages: {
                invalidData: 'Invalid input data.',
                fetchError: 'Unable to retrieve data from the server.'
            }
        },
        tips: {
            widgetTitle: 'Useful water saving tips',
            readMore: 'Read more',
            doItNow: 'Do it now',
            next: 'Next',
            previous: 'Previous',
            undo: 'Undo',
            done: "I've done it",
            addFailed: 'Error adding to Action Plan'
        },
        tipsLibrary: {
            actionPlanTitle: 'My action plan',
            actionPlanDescription: 'Select any tip to add it to your plan and track your progress.',
            completedTipsTitle: 'Completed',
            actionPlanReadMoreLabel: 'READ MORE',
            actionPlanDoneLabel: "I'VE DONE IT",
            readMoreButtonLabel: 'Read More',
            undoButtonLabel: 'Undo',
            doneButtonLabel: "I've done it",
            doItButtonLabel: 'Do it now',
            undoTooltipLabel: 'Undo tip',
            previousButtonLabel: 'Previous',
            nextButtonLabel: 'Next',
            backBtnLabel: 'Back to my consumption coach',
            actionPlan: {
                addSuccess: 'Tip added to Action Plan',
                addFailed: 'Error adding to Action Plan',
                completeSuccess: 'Tip completed',
                completeFailed: 'Error completing tip',
                unCompleteSuccess: 'Action performed successfully',
                unCompleteFailed: 'Error performing action',
                removeSuccess: 'Tip removed from Action Plan',
                removeFailed: 'Error removing from Action Plan',
                getTipsFailed: 'Error loading tips'
            }
        }
    },
    toast: {
        successMessage: 'Action succeeded',
        failureMessage: 'Action failed'
    },
    deliveryPointRequests: {
        requestsTracking: 'SUIVI DES DEMANDES DE BRANCHEMENT',
        request: 'DEMANDE DE BRANCHEMENT'
    },
    clientIdentity: {
        title: 'Client Identity',
        emailLabel: 'Email',
        mobilePhoneLabel: 'Mobile Phone',
        landlineLabel: 'Landline number',
        billingAddressLabel: 'Billing address',
        alreadyCanceled: 'Client already canceled'
    }
};
